const getDefaultStorage = (): Storage => {
  return sessionStorage;
};

export default getDefaultStorage;
